import React from 'react';
import PageContainer from '../container/PageContainer';
import ParentCard from './ParentCard';
import CusLink from '../material-ui/CusLink';
import ErrorBoundary from '../material-ui/error_boundary/ErrorBoundary';
import { useLocation, useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';

export default function CusPageCardContainer({
  title,
  children,
  backInfo = { text: '', to: '' },
  mySubheader,
  headTitle,
  footer,
  cardSX
}) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const location = useLocation();

  const fromBack = location.state?.from;
  const cusBackInfo = typeof backInfo == 'string' ? { text: '', to: '' } : backInfo;
  if (backInfo == 'auto') {
    cusBackInfo.to = fromBack;
    cusBackInfo.text = 'Back';
  }

  const Subheader = () => {
    if (!cusBackInfo.to) return <></>;
    return (
      <CusLink
        mt={1}
        onClick={cusBackInfo.getToLink ? () => navigate(cusBackInfo.getToLink()) : undefined}
        to={cusBackInfo?.to}
        text={cusBackInfo?.text}
      />
    );
  };

  const titleForHead = t(headTitle) || (typeof title == 'string' ? t(title) : '');

  return (
    <PageContainer title={titleForHead}>
      <ParentCard
        title={title}
        subheader={mySubheader || <Subheader />}
        sx={cardSX}
        cardContentSx={{ minHeight: 'calc(100svh - 180px)' }}
        footer={footer}>
        <ErrorBoundary>{children}</ErrorBoundary>
      </ParentCard>
    </PageContainer>
  );
}
